$(function(){
  refreshCheckoutBtn();
  // onloadShortenProdTitle();
  onloadSiblingsProducts();
  onloadPDPbutton();
  // setInterval(function(){
   
  // },1000);
  if (location.href.includes('/products')) {
  }

  setTimeout(function(){
    document.dispatchEvent(new 
      CustomEvent("swym:collections-loaded"));
      initFlickityYMAL();
  },1000);
  
});

refreshCheckoutBtn = () => {

  var myInterval = setInterval( function(){
    if ($('.cart__checkout.btn--loading').length > 0) {
      // console.log('refresh checkout btn');
      $('.cart__checkout.btn--loading').removeClass('btn--loading');
      // clearInterval(myInterval);
    }
  } , 5000);
}

//start: custom collection filter
jscCollectionFilterMobile = (e) => {
  var $thisContent = $(e).find('.jsc-filter-content');

  $thisContent.toggle();
  console.log('1');
}
jscCollectionFilter = (e,tabs) => {
  var $thisContent = $(e).find('.jsc-filter-content');
  var $thisTab = $(e).find('.jsc-filter-header');
  var $dropdownWidth = $thisContent.width();

  var $otherContent = $(e).siblings('.jsc-filter-each-tabs').find('.jsc-filter-content');
  var $otherTab = $(e).siblings('.jsc-filter-each-tabs').find('.jsc-filter-header');

  $thisContent.toggle();
  $(e).toggleClass("expanded");
  if ($(e).hasClass("expanded")) {
    $thisTab.css({
      // 'min-width': $dropdownWidth,
      // 'justify-content': 'end'
    });
  }
  else {
    $thisTab.css({
      // 'min-width': 'fit-content',
      // 'justify-content': 'start'
    });
  }

  $otherContent.css('display','none');
  $otherTab.css({
    'min-width': 'fit-content'
  });
  $(e).siblings('.jsc-filter-each-tabs').removeClass('expanded');
  
  // console.log($dropdownWidth);
  
}
//end: custom collection filter

//start: hover grid
jscHoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--previous').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--next').removeClass('d-none');

    // var $slick_arrow = $(e).find('.jsc-grid-images.slick-initialized .slick-arrow');
    // $slick_arrow.css({
    //   opacity: '1'
    // });
  }
}
jscOuthoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--previous').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--next').addClass('d-none');
    
    // var $slick_arrow = $(e).find('.jsc-grid-images.slick-initialized .slick-arrow');
    // $slick_arrow.css({
    //   opacity: '0'
    // });
  }
}
//end: hover grid
onloadShortenProdTitle = () => {
  if ($(window).width() < 380) {
    var maxCharacters = 16;
  }
  else if ($(window).width() < 480) {
    var maxCharacters = 23;
  }
   else if ($(window).width() < 798) {
    var maxCharacters = 42;
   }
   else if ($(window).width() < 1025) {
    var maxCharacters = 24;
   }
   else if ($(window).width() > 1026) {
    var maxCharacters = 38;
   } else {
    var maxCharacters = 30;
  }
  
  $(document).ready(function() {
    $(".grid-product__meta").each(function() {
      var productTitle = $(this).find(".grid-product__title");
      var originalText = productTitle.text();
  
      var maxTitleWidth = $(this).width(); // Get the grid container width
      var fontSize = parseFloat(productTitle.css("font-size"));
      // var maxCharacters = Math.floor(maxTitleWidth / fontSize);
      // var maxCharacters = Math.floor(maxTitleWidth / 10);
      
      console.log(maxTitleWidth,fontSize,maxCharacters);
      if (originalText.length > maxCharacters) {
        var truncatedText = originalText.substring(0, maxCharacters) + "...";
        productTitle.text(truncatedText);
      }
    });
  });
}

jscMobileGridLayout = (e,grid) => {
  
  var grid_width;
  var price_flex;
  if (grid == 'layout-switch--one-column') {
    grid_width = '100%';
    price_flex = 'row';
  }
  else if (grid == 'layout-switch--two-columns') {
    grid_width = '50%';
    price_flex = 'row';
  } else {
    grid_width = '33%';
    price_flex = 'column';
  }
  console.log(grid,grid_width);
  $(e).addClass('layout-switch--active');
  $(e).siblings('.layout-switch').removeClass('layout-switch--active');
  $(e).parents('.jsc-searchspring').find('.jsc-collection-grids .grid__item').css({
    'width' : grid_width 
  });
  $(e).parents('.jsc-searchspring').find('.jsc-collection-grids').css({
    'display' : 'flex' ,
    'flex-wrap': 'wrap'
  });
  $(e).parents('.jsc-searchspring').find('.jsc-collection-grids .grid__item .jsc-product-price-grid').css({
    'flex-direction' : price_flex
  });

  // reinitImageSliderGrid();
  
}

var display_index = 1;
jscGridPrevImage = (e,seq) => {
  var media_container = $(e).parents('.grid-product__image-mask').find('.grid-product__link');
  var total_media = parseInt(media_container.find('.jsc-media-details').attr('data-total-img'));

  if (seq == 'next') {
    display_index += 1;
  } else if (seq == 'prev') {
    display_index -= 1;
  }
  else {
  }

  if (display_index > total_media) {
    display_index = 1;
  }
  if (display_index < 1) {
    display_index = total_media;
  }

  media_container.find('.image-wrap.custom').each(function(){
    var $thisImage = $(this).attr('data-image-index');
    var $thisIndex = parseInt($thisImage);
    $(this).removeClass('jsc-active-image');
    $(this).addClass('jsc-inactive-image');

    if ($thisIndex == display_index) {
      $(this).addClass('jsc-active-image');
      $(this).removeClass('jsc-inactive-image');
    }

  })
  console.log('click image',display_index,total_media);
}
mobileGridImageSwipe = (e) => {
  if($(window).width()< 480) {
    var media_container = $(e).parents('.grid-product__image-mask').find('.grid-product__link');
    var total_media = parseInt(media_container.find('.jsc-media-details').attr('data-total-img'));

    display_index += 1;

    if (display_index > total_media) {
      display_index = 1;
    }
    if (display_index < 1) {
      display_index = total_media;
    }

    media_container.find('.image-wrap.custom').each(function(){
      var $thisImage = $(this).attr('data-image-index');
      var $thisIndex = parseInt($thisImage);
      $(this).removeClass('jsc-active-image');
      $(this).addClass('jsc-inactive-image');

      if ($thisIndex == display_index) {
        $(this).addClass('jsc-active-image');
        $(this).removeClass('jsc-inactive-image');
      }

    })

  }
  
}

//start: update pdp ATC button
onloadPDPbutton = () => {
  var $oosBtn = $('.jsc-pdp-atc-btn-container.jsc-oos-button');
  var $oosBtnInner = $('.jsc-pdp-atc-btn-container.jsc-oos-button .btn.add-to-cart');

  if ($oosBtn.length > 0) {
    console.log('button oos');
    var timer = setInterval(function() {
      var $wishlistBtn = $('.jsc-pdp-atc-btn-container .swym-button-bar');
      var $klaviyoBtn = $('.jsc-pdp-atc-btn-container .klaviyo-bis-trigger')

      if ($wishlistBtn.length > 0) {
        console.log('button wishlist');
        if ($klaviyoBtn.length > 0 ) {
          console.log('button klaviyo');
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').css({
            'display': 'block'
          });
          // setTimeout(function(){
            $oosBtnInner.css({
              'position': 'absolute',
              'z-index': '-1'
            });
          // },100);
          
          clearInterval(timer);
        }
      }
    })
  }
}
//end: update pdp ATC button

jscSelectVariant = (e,size,var_avail) => {
  var $label = $(e).parents('.variant-wrapper').find('.jsc-pdp-size');
  $label.find('.jsc-selected-variant').text(size);
  // console.log($label,size);
  
  if (var_avail == 'true') {
    $('.jsc-pdp-atc-btn-container').removeClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container .btn.add-to-cart').css({
      'position': 'relative',
      'z-index': 'auto'
    });
  } else {
    $('.jsc-pdp-atc-btn-container').addClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container.jsc-oos-button .btn.add-to-cart').css({
      'position': 'absolute',
      'z-index': '-1'
    });
    $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
  }
}

//start: pdp size guide popup
jscDisablePageScroll = (e,check) => {

  if (check == 'true') {
    $(e).parents('body').addClass('modal-open');
  } else {
    $(e).parents('body').removeClass('modal-open');
  }
  
}
//end: pdp size guide popup

//start:pdp color siblings
onloadSiblingsProducts = () => {
  var $prod_details = $('.jsc-prod-json-details').find('.jsc-each-prod-json');
  var $prod_sibs_container = $('.jsc-sibling-products-content');
  var $prod_sibs_grid = $prod_sibs_container.find('.jsc-each-colour-url');
  var $current_url = window.location.href;
  // console.log($current_url);

  $prod_details.each(function(){
    var $this_graphql = $(this).attr('data-graphql');
    // console.log($this_graphql);

        // Define your GraphQL query

        const graphqlQuery = `
        query {
          product(id: "` + $this_graphql + `") {
            id
            title
            handle
            variants(first: 10) {
              edges {
                node {
                  title
                }
              }
            }
            featuredImage {
              id
              src
            }
          }
        }
        `;
        
        // Set the endpoint URL
        const endpointUrl = 'https://silenttheory.myshopify.com/api/2023-10/graphql.json';

        // Send the GraphQL request using jQuery
        $.ajax({
          url: endpointUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'f856941de361b6ed5cb2b4a6160b4ad0', 
          },
          data: JSON.stringify({ query: graphqlQuery }),
          success: function(response) {
            // Handle the response here
            // console.log('Result',response);
            var prod_title = response.data.product.title;
            var prod_handle = response.data.product.handle;
            var prod_img = response.data.product.featuredImage.src;
            // var prod_url = 'https://www.foxwoodclothing.com.au/products/' + prod_handle;
            var prod_url = '/products/' + prod_handle;
            var variant_title = response.data.product.variants.edges[0].node.title;
            var variant_color = variant_title.split(" / ");
            var type_tab;
            var var_color = '';

            if (variant_color[0] !== undefined ) {
              var_color = variant_color[0];
            } else {
              var_color = '';
            }
            var color_handle = var_color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

            if ($current_url.includes(color_handle) && var_color != '') {
              // console.log('active',color_handle);
              type_tab = 'jsc-active-col';
            } else {
              // console.log('inactive',color_handle);
              type_tab = 'jsc-inactive-col';
            }
            // console.log(type_tab,color_handle);
            
            var $color_grid = '<a href="' + prod_url + '" class="jsc-each-colour-url"><div class="jsc-each-colour-prod ' + type_tab + '"><img class="jsc-each-colour-prod-img" src="' + prod_img + '" alt="' + prod_title +'"></div><span>' + var_color + '</span></a>';
            // console.log($color_grid);
            // $prod_sibs_container.append($color_grid);

            $prod_sibs_grid.each(function(){
              var $thisGraphql = $(this).attr('data-graphql');
              var $thisUrl;
              var $thisColor = $(this).find('span');
              var $thisColorImg = $(this).find('.jsc-each-colour-prod-img');             

              if ($thisGraphql == $this_graphql) {
                // console.log($color_grid);
                $thisUrl = $(this).attr("href",prod_url);
                $thisColor.text(var_color);
                $thisColorImg.attr("src",prod_img);
                $thisColorImg.attr("alt",prod_title);
                
                $(this).addClass(type_tab);
                $(this).removeClass('d-none');
                
              }
            });
          },
          error: function(error) {
            // Handle any errors here
            console.error('Error!',error);
          }
        });
  });


  
}
//end:pdp color siblings

//start: initiate flickity slider in pdp ymal section
initFlickityYMAL = () => {
  var $ymal_section_flickity = $('.jsc-ymal-flickity .grid');
  //console.log('$ymal_section_flickity',$ymal_section_flickity);
  if ($(window).width() > 799) {
    if ($ymal_section_flickity.length > 0) {
      
      $ymal_section_flickity.flickity({
        // options
        prevNextButtons : true,
        pageDots : false,
        wrapAround : true,
        contain: true,
        cellAlign: 'left',
        draggable: true,
        // imagesLoaded : true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  }
}
//end: initiate flickity slider in pdp ymal section

// Class for collapsible tab
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.disclosure = this.querySelector('details');
    this.toggle = this.querySelector('summary');
    this.panel = this.toggle.nextElementSibling;
    this.init();
  }

  init() {
    // Check if the content element has a CSS transition.
    if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
      this.toggle.addEventListener('click', this.handleToggle.bind(this));
      this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
    }
  }

  /**
   * Handles 'click' events on the summary element.
   * @param {object} evt - Event object.
   */
  handleToggle(evt) {
    evt.preventDefault();

    if (!this.disclosure.open) {
      this.open();
    } else {
      this.close();
    }
  }

  /**
   * Handles 'transitionend' events on the details element.
   * @param {object} evt - Event object.
   */
  handleTransitionEnd(evt) {
    if (evt.target !== this.panel) return;

    if (this.disclosure.classList.contains('is-closing')) {
      this.disclosure.classList.remove('is-closing');
      this.disclosure.open = false;
    }

    this.panel.removeAttribute('style');
  }

  /**
   * Adds inline 'height' style to the content element, to trigger open transition.
   */
  addContentHeight() {
    this.panel.style.height = `${this.panel.scrollHeight}px`;
  }

  /**
   * Opens the details element.
   */
  open() {
    // Set content 'height' to zero before opening the details element.
    this.panel.style.height = '0';

    // Open the details element
    this.disclosure.open = true;

    // Set content 'height' to its scroll height, to enable CSS transition.
    this.addContentHeight();
  }

  /**
   * Closes the details element.
   */
  close() {
    // Set content height to its scroll height, to enable transition to zero.
    this.addContentHeight();

    // Add class to enable styling of content or toggle icon before or during close transition.
    this.disclosure.classList.add('is-closing');

    // Set content height to zero to trigger the transition.
    // Slight delay required to allow scroll height to be applied before changing to '0'.
    setTimeout(() => {
      this.panel.style.height = '0';
    });
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
//end class for collapsible tab